/* tslint:disable */
/* eslint-disable */
/**
 * Melco Tracking APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrackingTrackingModelsAnalyticsFileDetails
 */
export interface TrackingTrackingModelsAnalyticsFileDetails {
    /**
     * 
     * @type {string}
     * @memberof TrackingTrackingModelsAnalyticsFileDetails
     */
    file_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingTrackingModelsAnalyticsFileDetails
     */
    file_signature?: string | null;
}

export function TrackingTrackingModelsAnalyticsFileDetailsFromJSON(json: any): TrackingTrackingModelsAnalyticsFileDetails {
    return TrackingTrackingModelsAnalyticsFileDetailsFromJSONTyped(json, false);
}

export function TrackingTrackingModelsAnalyticsFileDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackingTrackingModelsAnalyticsFileDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file_name': !exists(json, 'file_name') ? undefined : json['file_name'],
        'file_signature': !exists(json, 'file_signature') ? undefined : json['file_signature'],
    };
}

export function TrackingTrackingModelsAnalyticsFileDetailsToJSON(value?: TrackingTrackingModelsAnalyticsFileDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file_name': value.file_name,
        'file_signature': value.file_signature,
    };
}


